import React, { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function AdminKioskOrderViewPage() {
  const [searchParams] = useSearchParams();
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(true);

  const path = useMemo(() => {
    const qs = searchParams.toString();
    return `/api/pos/admin-kiosk-order-view${qs ? `?${qs}` : ''}`;
  }, [searchParams]);

  const loadPage = async () => {
    setLoading(true);
    try {
      const res = await fetch(path, { credentials: 'same-origin', cache: 'no-store' });
      const text = await res.text();
      setHtml(text);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPage();
  }, [path]);

  useEffect(() => {
    const root = document.getElementById('admin-kiosk-order-view-root');
    if (!root) return;
    const orderId = parseInt(searchParams.get('order_id') || '0', 10);

    window.setStatus = async function setStatus(kor) {
      const MAP = { '접수': 'ACCEPTED', '준비중': 'COOKING', '완료': 'DONE', '취소': 'CANCELLED' };
      const st = MAP[kor] || kor;
      if (!window.confirm(`상태를 ${kor}(으)로 변경할까요?`)) return;

      const res = await fetch('/api/pos/admin-kiosk-order-update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ order_id: orderId, current_status: st }),
        credentials: 'same-origin',
      });
      const data = await res.json();
      if (!data.ok) { alert(data.msg || '실패'); return; }
      const el = document.getElementById('currentStatusText');
      if (el) el.textContent = kor;
      loadPage();
    };

    window.setDeliveryStatus = async function setDeliveryStatus(ds) {
      if (!window.confirm(`배송상태를 "${ds}"(으)로 변경할까요?`)) return;
      const res = await fetch('/api/pos/admin-delivery-status-ajax', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ order_id: orderId, delivery_status: ds }),
        credentials: 'same-origin',
      });
      const data = await res.json();
      if (!data.ok) { alert(data.msg || '실패'); return; }
      loadPage();
    };

    return () => {
      delete window.setStatus;
      delete window.setDeliveryStatus;
    };
  }, [html, searchParams]);

  if (loading) return <div className="p-3">로딩 중...</div>;
  return <div id="admin-kiosk-order-view-root" dangerouslySetInnerHTML={{ __html: html }} />;
}
